import member1 from "../assets/images/arts/1.jpg";
import member2 from "../assets/images/arts/4.jpg"
import member3 from "../assets/images/arts/8.jpg"
import member4 from "../assets/images/arts/10.jpg"
import member5 from "../assets/images/arts/2.jpg"

const OurTeam = () => {
    const images = [
        {
            name: 'CHAIRMAN APE',
            role: 'Chief Programmer',
            img: member1
        },
        {
            name: 'CHIEF EXECUTIVE APE',
            role: 'Project Director',
            img: member2
        },
        {
            name: 'MANAGEMENT APE',
            role: 'Art Director',
            img: member3
        },
        {
            name: 'OPERATIONS APE',
            role: 'Social Media & Marketing',
            img: member4
        }
    ];
    return (
        <section id="team">
            <div className="sec-heading-wrapper">
                <h1 className="sec-heading" data-aos="zoom-out">The Team</h1>
            </div>
            <div className="team-wrapper row">
                {images.map((data, ind) => {
                    return (
                        <div data-aos="fade-up" key={ind} className="row column team-card">
                            <img src={data.img} alt={data.name} />
                            <div className="member-card-body row column">
                                <h2>{data.name}</h2>
                                <p className="role-">{data.role}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default OurTeam

